import React from 'react';

import IntegrationImage, { integrationImageById } from 'assets/img/integrations';

import styles from './ManageAppsIntegrationIcon.module.scss';

interface ManageAppsIntegrationIconProps extends StyleProps {
  /** @string - Integration name */
  itemIntegrationName: string;
}

export const ManageAppsIntegrationIcon: React.FC<ManageAppsIntegrationIconProps> = ({
  itemIntegrationName,
}) => {
  const integrationIcon = integrationImageById(
    itemIntegrationName,
    IntegrationImage,
    true,
    styles.icon
  );

  return (
    <>
      {itemIntegrationName && integrationIcon}
    </>
  );
};
